// eslint-disable-next-line
export function serializeToQuerystring(source) {
  const serialized = [];
  Object.keys(source).forEach((option) => {
    const name = encodeURIComponent(option);
    const value = encodeURIComponent(source[option]);
    serialized.push(`${name}=${value}`);
  });

  return serialized.join('&');
}

// eslint-disable-next-line
export function parseFromQuerystring(query) {
  const parsed = {};
  query.substring(1).replace(/([^=&]+)=([^&]*)/g, (m, key, value) => {
    parsed[window.decodeURIComponent(key)] = window.decodeURIComponent(value);
  });

  return parsed;
}
